import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../../data/BaseUrl";

export const fetchApiData = createAsyncThunk(
  "api/fetchApiData",
  async ({ method, endpoint, payload, token, format }) => {
    try {
      let requestOptions = {
        method: method || "GET",
        headers: {
          "Content-Type":
            format === "formData" ? "multipart/form-data" : "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      if (method === "POST" || method === "PUT" || method === "PATCH") {
        requestOptions.body =
          format === "formData" ? payload : JSON.stringify(payload);
      }

      if (method === "GET" && payload.filters) {
        const filteredParams = Object.entries(payload.filters)
          .filter(([key, value]) => value !== "")
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join("&");

        if (filteredParams) {
          endpoint += `?${filteredParams}`;
        }
      }

      const url = BASE_URL ? BASE_URL + endpoint : endpoint;
      const response = await fetch(url, requestOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
);

export const fetchApiDataDup = createAsyncThunk(
  "api/fetchApiDataDup",
  async ({ method, endpoint, payload, token, format }) => {
    try {
      let requestOptions = {
        method: method || "GET",
        headers: {
          "Content-Type":
            format === "formData" ? "multipart/form-data" : "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      if (method === "POST" || method === "PUT") {
        requestOptions.body =
          format === "formData" ? payload : JSON.stringify(payload);
      }

      if (method === "GET" && payload.filters) {
        const filteredParams = Object.entries(payload.filters)
          .filter(([key, value]) => value !== "")
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join("&");

        if (filteredParams) {
          endpoint += `?${filteredParams}`;
        }
      }

      const url = BASE_URL ? BASE_URL + endpoint : endpoint;
      const response = await fetch(url, requestOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
);

export const fetchApiDataDup3 = createAsyncThunk(
  "api/fetchApiDataDup3",
  async ({ method, endpoint, payload, token, format }) => {
    try {
      let requestOptions = {
        method: method || "GET",
        headers: {
          "Content-Type":
            format === "formData" ? "multipart/form-data" : "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      if (method === "POST" || method === "PUT") {
        requestOptions.body =
          format === "formData" ? payload : JSON.stringify(payload);
      }

      if (method === "GET" && payload.filters) {
        const filteredParams = Object.entries(payload.filters)
          .filter(([key, value]) => value !== "")
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join("&");

        if (filteredParams) {
          endpoint += `?${filteredParams}`;
        }
      }

      const url = BASE_URL ? BASE_URL + endpoint : endpoint;
      const response = await fetch(url, requestOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
);

export const fetchExportApiData = createAsyncThunk(
  "api/fetchExportApiData",
  async ({ method, endpoint, payload, token }) => {
    try {
      let requestOptions = {
        method: method || "GET",
        headers: {
          "Content-Type": "csv",
          Authorization: `Bearer ${token}`,
        },
      };

      if (method === "POST" || method === "PUT") {
        requestOptions.body = JSON.stringify(payload);
      }

      if (method === "GET" && payload.filters) {
        const filteredParams = Object.entries(payload.filters)
          .filter(([_, value]) => value !== "")
          .map(([key, value]) => `${key}=${value}`)
          .join("&");

        if (filteredParams) {
          endpoint += `?${filteredParams}`;
        }
      }

      const url = BASE_URL ? BASE_URL + endpoint : endpoint;
      const response = await fetch(url, requestOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return response.text();
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
);

export const commonPostPutApiDUMMY = createAsyncThunk(
  "api/commonPostPutApi",
  async ({ method, endpoint, payload, token }) => {
    try {
      let requestOptions = {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      requestOptions.body = JSON.stringify(payload);

      const url = BASE_URL ? BASE_URL + endpoint : endpoint;
      const response = await fetch(url, requestOptions);

      console.log("response is", response);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
);

export const commonPostPutApi = createAsyncThunk(
  "api/commonPostPutApi",
  async ({ method, endpoint, payload, token }) => {
    try {
      let requestOptions = {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      requestOptions.body = JSON.stringify(payload);

      const url = BASE_URL ? BASE_URL + endpoint : endpoint;
      const response = await fetch(url, requestOptions);

      const responseData = await response.json();

      if (!response.ok) {
        if (responseData.message) {
          throw new Error(responseData.message);
        }
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return responseData;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
);

export const commonPostPutApi1 = createAsyncThunk(
  "api/commonPostPutApi1",
  async ({ method, endpoint, payload, token }) => {
    try {
      let requestOptions = {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      requestOptions.body = JSON.stringify(payload);

      const url = BASE_URL ? BASE_URL + endpoint : endpoint;
      const response = await fetch(url, requestOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
);

export const commonPostPutFormData = createAsyncThunk(
  "api/commonPostPutFormData",
  async ({ method, endpoint, requestBody, token }) => {
    try {
      const response = await fetch(`${BASE_URL}${endpoint}`, {
        method: method,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: requestBody,
      });

      if (!response.ok) {
        throw new Error(
          "commonPostPutFormData Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const commonApiSlice = createSlice({
  name: "common",
  initialState: {
    data: null,
    loading: false,
    error: null,

    dataDup: null,
    loadingDup: false,
    errorDup: null,

    dataDup3: null,
    loadingDup3: false,
    errorDup3: null,

    exportData: null,
    exportLoading: false,
    exportError: null,

    postPutData: null,
    postPutLoading: false,
    postPutError: null,

    postPutData1: null,
    postPutLoading1: false,
    postPutError1: null,

    postPutDataFormData: null,
    postPutLoadingFormData: false,
    postPutErrorFormData: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchApiData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApiData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchApiData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to fetch data";
      })

      .addCase(fetchApiDataDup.pending, (state) => {
        state.loadingDup = true;
        state.errorDup = null;
      })
      .addCase(fetchApiDataDup.fulfilled, (state, action) => {
        state.loadingDup = false;
        state.dataDup = action.payload;
        state.errorDup = null;
      })
      .addCase(fetchApiDataDup.rejected, (state, action) => {
        state.loadingDup = false;
        state.errorDup = action.error?.message || "Failed to fetch data";
      })

      .addCase(fetchApiDataDup3.pending, (state) => {
        state.loadingDup3 = true;
        state.errorDup3 = null;
      })
      .addCase(fetchApiDataDup3.fulfilled, (state, action) => {
        state.loadingDup3 = false;
        state.dataDup3 = action.payload;
        state.errorDup3 = null;
      })
      .addCase(fetchApiDataDup3.rejected, (state, action) => {
        state.loadingDup3 = false;
        state.errorDup3 = action.error?.message || "Failed to fetch data";
      })

      .addCase(fetchExportApiData.pending, (state) => {
        state.exportLoading = true;
        state.exportError = null;
      })
      .addCase(fetchExportApiData.fulfilled, (state, action) => {
        state.exportLoading = false;
        state.exportData = action.payload;
        state.exportError = null;
      })
      .addCase(fetchExportApiData.rejected, (state, action) => {
        state.exportLoading = false;
        state.exportError =
          action?.exportError?.message || "Failed to fetch data";
      })

      .addCase(commonPostPutApi.pending, (state) => {
        state.postPutLoading = true;
        state.postPutError = null;
      })
      .addCase(commonPostPutApi.fulfilled, (state, action) => {
        state.postPutLoading = false;
        state.postPutData = action.payload;
        state.postPutError = null;
      })
      .addCase(commonPostPutApi.rejected, (state, action) => {
        state.postPutLoading = false;
        state.postPutError =
          action.postPutError?.message || "Failed to fetch data";
      })

      .addCase(commonPostPutFormData.pending, (state) => {
        state.postPutLoadingFormData = true;
        state.postPutErrorFormData = null;
      })
      .addCase(commonPostPutFormData.fulfilled, (state, action) => {
        state.postPutLoadingFormData = false;
        state.postPutDataFormData = action.payload;
        state.postPutErrorFormData = null;
      })
      .addCase(commonPostPutFormData.rejected, (state, action) => {
        state.postPutLoadingFormData = false;
        state.postPutErrorFormData =
          action.postPutErrorFormData?.message || "Failed to fetch data";
      })

      .addCase(commonPostPutApi1.pending, (state) => {
        state.postPutLoading1 = true;
        state.postPutError1 = null;
      })
      .addCase(commonPostPutApi1.fulfilled, (state, action) => {
        state.postPutLoading1 = false;
        state.postPutDataFormData = action.payload;
        state.postPutError1 = null;
      })
      .addCase(commonPostPutApi1.rejected, (state, action) => {
        state.postPutLoading1 = false;
        state.postPutError1 =
          action.postPutError1?.message || "Failed to fetch data";
      });
  },
});

export default commonApiSlice.reducer;